import { call, put } from 'redux-saga/effects';
import { reSend } from 'modules/Taps/services/API/3ndflView';
import { resendDeclarationError, resendDeclarationSuccess } from '../redux/actions';
import config from 'config';
import { remotePaths } from 'router/routes';

export function* resendDeclarationSaga({ payload: { cardId } }) {
  const { isOk, data, error } = yield call(reSend, cardId);
  if (isOk) {
    yield put(resendDeclarationSuccess(data));
    yield config.goToNewLK(remotePaths.situations);
  } else {
    yield put(resendDeclarationError(error));
  }
}
